module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/administracion/categorias-gastos/subcategorias-gastos-modal/subcategorias-gastos-modal.component.scss
// module id = ./src/app/administracion/categorias-gastos/subcategorias-gastos-modal/subcategorias-gastos-modal.component.scss
// module chunks = main